import {
  FETCH_CONTACTS_FAILURE,
  FETCH_CONTACTS_REQUESTED,
  FETCH_CONTACTS_SUCCESS,
} from 'actiontypes/contacts';
import ContactService from 'services/ContactService';

const service = new ContactService();

export default function fetchContacts() {
  return (dispatch) => {
    dispatch(fetchContactsRequested());
    return service.fetch()
      .then(({ data }) => {
        dispatch(fetchContactsSuccess(data));
        return data;
      })
      .catch((error) => {
        dispatch(fetchContactsFailure(error));
      });
  };
}

export const fetchContactsRequested = () => ({ type: FETCH_CONTACTS_REQUESTED });

export const fetchContactsSuccess = payload => ({ payload, type: FETCH_CONTACTS_SUCCESS });

export const fetchContactsFailure = () => ({ type: FETCH_CONTACTS_FAILURE });